import React, { Component } from "react";
import { StoryLine } from "./type";
import StorylinePath from "./StorylinePath";

type Props = {
  containerX: number;
  barHeight: number;
  barStartY: number;
  riskValue: number;
  riskColor: string;
  character: string;
  storyline: StoryLine;
};

type State = {
  isFocusing: boolean;
  barScale: number;
  barRatio: number;
  gapRatio: number;
  defaultStrokeWidth: number;
  activateStrokeWidth: number;
};

export default class StorylineBar extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isFocusing: false,
      barScale: 0.8, // scale bar height
      barRatio: 0.4, // bar width
      gapRatio: 0.2, // gap width
      defaultStrokeWidth: 2,
      activateStrokeWidth: 5,
    };
  }

  getGapPathD(start: number[], end: number[]) {
    const xInterval = end[0] - start[0];
    const c1x = start[0] + xInterval / 3;
    const c2x = end[0] - xInterval / 3;
    return `M ${start[0]} ${start[1]} C ${c1x} ${start[1]} ${c2x} ${end[1]} ${end[0]} ${end[1]}`;
  }

  render() {
    const {
      containerX,
      barHeight,
      barStartY,
      riskValue,
      riskColor,
      character,
      storyline,
    } = this.props;
    const {
      barRatio,
      gapRatio,
      isFocusing,
      defaultStrokeWidth,
      activateStrokeWidth,
      barScale,
    } = this.state;
    const textRatio = 1 - barRatio - gapRatio;
    const gapPathD = this.getGapPathD(
      [containerX * (1 - gapRatio), barStartY + barHeight / 2],
      storyline[0][0]
    );
    const barWidth = containerX * barRatio * riskValue;
    const barStartX = containerX - containerX * gapRatio - barWidth;
    return (
      <g
        onMouseEnter={() => this.setState({ isFocusing: true })}
        onMouseLeave={() => this.setState({ isFocusing: false })}
      >
        <text
          x={10}
          y={`${barStartY + barHeight / 2}`}
          style={{ dominantBaseline: "middle" }}
        >
          {character.split("_")[1]}
        </text>
        <rect
          x={`${containerX * textRatio}`}
          y={`${barStartY + (barHeight * (1 - barScale)) / 2}`}
          width={`${containerX * barRatio}`}
          height={`${barHeight * barScale}`}
          style={{
            fill: isFocusing ? "#888" : "#E6E6E6",
            stroke: isFocusing ? "#888" : "#E6E6E6",
            strokeWidth: 2,
            opacity: "0.6",
          }}
        />
        <rect
          x={`${barStartX}`}
          y={`${barStartY + (barHeight * (1 - barScale)) / 2}`}
          width={`${barWidth}`}
          height={`${barHeight * barScale}`}
          style={{ fill: `${riskColor}` }}
        />
        <path
          d={gapPathD}
          stroke={`${riskColor}`}
          fill="none"
          strokeWidth={isFocusing ? activateStrokeWidth : defaultStrokeWidth}
        />
        <StorylinePath
          storyline={storyline}
          storylineName={character}
          storylineWidth={isFocusing ? activateStrokeWidth : defaultStrokeWidth}
          storylineColor={riskColor}
        />
      </g>
    );
  }
}
